import { VehiculeCheckFilterType } from '@/entities/vehicle';
import { TVehiculeSchema } from '@/schemas/vehicule/vehicule.schema';
import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import { mapVehicleFilterAPI } from '@/utils/map.utils';
import { ListAllVehicule, TotalActiveVehicule } from '../entities/vehicule';
import { TVehiculeUserSchema } from '@/schemas/vehicule-user/vehicule-user.schema';

const VEHICULE_URI = '/vehicule';

export const createNewVehicule = async (
  vehicule: TVehiculeSchema,
  query?: TVehiculeUserSchema,
) => {
  let url = `${VEHICULE_URI}`;
  const params = new URLSearchParams();

  if (query?.createdByUserId) {
    params.append('createdByUserId', query?.createdByUserId);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.POST,
    body: vehicule,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getMatchingVehiculeError = async (query?: TVehiculeSchema) => {
  let url = `${VEHICULE_URI}/matchingObjectError`;
  const params = new URLSearchParams();

  if (query?.id) {
    params.append('id', query.id);
  }

  if (query?.ownerGroupId) {
    params.append('ownerGroupId', query.ownerGroupId);
  }

  if (query?.ownerCompanyId) {
    params.append('ownerCompanyId', query.ownerCompanyId);
  }

  if (query?.vin) {
    params.append('vin', query.vin);
  }

  if (query?.licensePlateNumber) {
    params.append('licensePlateNumber', query.licensePlateNumber);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getExistingVehicule = async (query?: TVehiculeSchema) => {
  let url = `${VEHICULE_URI}/existing`;
  const params = new URLSearchParams();

  if (query?.vin) {
    params.append('vin', query.vin);
  }

  if (query?.licensePlateNumber) {
    params.append('licensePlateNumber', query.licensePlateNumber);
  }

  if (query?.brand) {
    params.append('brand', query.brand);
  }

  if (query?.model) {
    params.append('model', query.model);
  }

  if (query?.ownerGroupId) {
    params.append('ownerGroupId', query.ownerGroupId);
  }

  if (query?.ownerCompanyId) {
    params.append('ownerCompanyId', query.ownerCompanyId);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const listAllVehicules = async (query?: ListAllVehicule) => {
  let url = `${VEHICULE_URI}/allVehicules`;
  const params = new URLSearchParams();

  if (query?.userId) {
    params.append('userId', query.userId);
  }

  if (query?.groupId) {
    params.append('groupId', query.groupId);
  }

  if (query?.companyId) {
    params.append('companyId', query.companyId);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAllVehicules = async (
  filter: VehiculeCheckFilterType,
  page: number,
  limit: number,
  sortBy?: string,
  sortDirection?: 'asc' | 'desc',
) => {
  let url = `${VEHICULE_URI}/all?${mapVehicleFilterAPI(
    filter,
  )}&page=${page}&limit=${limit}`;

  // Add sort parameters if provided
  if (sortBy) {
    url += `&sortBy=${sortBy}&sortDirection=${sortDirection || 'asc'}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getTotalActiveVehicules = async (query?: TotalActiveVehicule) => {
  return requestApi({
    url: `${VEHICULE_URI}/totalActive${
      query?.userId ? `?userId=${query?.userId}` : ''
    }`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getVehiculeById = async (id: string) => {
  return requestApi({
    url: `${VEHICULE_URI}/${id}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateVehicule = async (vehicule: TVehiculeSchema) => {
  return requestApi({
    url: `${VEHICULE_URI}/update`,
    method: HTTP_METHOD.PATCH,
    body: vehicule,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateManyVehicules = async (vehicules: TVehiculeSchema[]) => {
  return requestApi({
    url: `${VEHICULE_URI}/updateMany`,
    method: HTTP_METHOD.PATCH,
    body: vehicules,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const importVehicule = async (vehicule: TVehiculeSchema[]) => {
  return requestApi({
    url: `${VEHICULE_URI}/import`,
    method: HTTP_METHOD.POST,
    body: vehicule,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const deleteVehicule = async (id: string) => {
  return requestApi({
    url: `${VEHICULE_URI}/delete/${id}`,
    method: HTTP_METHOD.DELETE,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const deleteManyVehicules = async (ids: string[]) => {
  return requestApi({
    url: `${VEHICULE_URI}/deleteMany`,
    method: HTTP_METHOD.DELETE,
    body: ids,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
